import { apiClient } from "../config/api.config";
import i18n from "../i18n";

// NOTE: apiClient's baseURL already carries the /api/v1 prefix (see
// createEnvConfig in @ews-admin/global-design-system) — this path must NOT
// repeat /api, or the request resolves to /api/v1/api/promotion/... and 404s.
// The BFF localises the promotion label from ?lang (defaults to fr without it).
export function getActivePromotions(facilityId: string | number) {
  const lang = (i18n.language || "fr").split("-")[0].toLowerCase();
  return apiClient.request({
    method: "get",
    url: `/promotion/facility/${facilityId}`,
    params: { lang },
  });
}
